const LOGO = "https://customer-assets.emergentagent.com/job_calma-sutras/artifacts/hxuq3qau_Untitled%20design%20%289%29.png";

const navLinks = [
  { l: "Story", h: "#showcase" },
  { l: "Cards", h: "#gallery" },
  { l: "Sutras", h: "#sutras" },
  { l: "Author", h: "#author" },
  { l: "Connect", h: "#contact" },
];

export default function Footer() {
  return (
    <footer className="py-10 sm:py-14 px-5 md:px-10 border-t border-[#464646]/10 bg-[#fff8f3]" data-testid="footer">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
          <div className="col-span-2 md:col-span-1">
            <img src={LOGO} alt="Calmasutras" loading="lazy" decoding="async" width="360" height="200" className="h-12 sm:h-14 w-auto mb-4" style={{ filter: "invert(1)" }} />
            <p className="text-[11px] text-[#464646]/55 leading-relaxed max-w-xs">A game of choice within the game of chance.</p>
          </div>
          <div>
            <p className="text-[9px] uppercase tracking-[0.3em] text-[#96aeb4] mb-3 font-semibold">Navigate</p>
            {navLinks.map(n => (
              <button key={n.h} onClick={() => document.querySelector(n.h)?.scrollIntoView({ behavior: "smooth" })}
                className="block text-xs text-[#464646]/60 hover:text-[#464646] transition-colors mb-1.5">{n.l}</button>
            ))}
          </div>
          <div>
            <p className="text-[9px] uppercase tracking-[0.3em] text-[#96aeb4] mb-3 font-semibold">Conceptualised by</p>
            <p className="text-xs text-[#464646]/65 mb-3">
              <a href="https://www.revurge.com" target="_blank" rel="noopener noreferrer"
                className="hover:text-[#464646] transition-colors">revurge</a>
              <span className="mx-1.5 text-[#464646]/30">×</span>
              <a href="https://www.become.team" target="_blank" rel="noopener noreferrer"
                className="hover:text-[#464646] transition-colors">become</a>
            </p>
            <p className="text-[10px] text-[#464646]/45">Author · <a href="https://www.rajeshsetty.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#96aeb4] transition-colors">Rajesh Setty</a></p>
          </div>
        </div>
        <div className="mt-8 pt-5 border-t border-[#464646]/8 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          <p className="text-[10px] text-[#464646]/40">&copy; {new Date().getFullYear()} Calmasutras · A Rajesh Setty × Revurge Production</p>
          <a
            href="/affiliates"
            className="group inline-flex items-center gap-2 rounded-full pl-3 pr-1 py-1 bg-white border border-[#464646]/12 hover:border-[#464646]/30 hover:bg-[#a6c1a8]/10 transition-all duration-300 shadow-[0_1px_0_rgba(70,70,70,0.04)]"
            data-testid="footer-affiliate-link"
          >
            <span className="text-[10px] uppercase tracking-[0.22em] text-[#464646]/65 group-hover:text-[#464646] font-semibold">
              Become an affiliate
            </span>
            <span className="inline-flex items-center gap-1 rounded-full bg-[#464646] group-hover:bg-[#587e62] text-[#fff8f3] text-[10px] font-semibold px-2.5 py-1 transition-colors">
              Earn 15%
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="transition-transform duration-300 group-hover:translate-x-0.5">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}
